<template>
  <q-layout view="lHh Lpr lFf">
    <Header />
    <q-page-container>
      <q-page padding>
        <div class="row q-pt-lg text-grey-9">
          <div class="col"></div>
          <div class="col-5" style="max-width: 600px">
            <span class="text-h5">Créer son compte</span>
            <q-separator class="q-mt-sm q-mb-lg"/>
              <q-form
                @submit="onSubmit"
                class="q-pt-sm"
              >
                <q-select
                  v-model="userType"
                  :options="userTypeOptions"
                  emit-value
                  map-options
                  label="Type d'utilisateur"
                  color="grey-9"
                  filled
                  :error="!!errors.userType"
                  :error-message="errors.userType"
                  class="q-mb-md"
                  @input="clearError('userType')"
                />
                <q-input
                  v-model="organizationName"
                  type="text"
                  :label="organizationLabel"
                  color="grey-9"
                  clearable
                  filled
                  :error="!!errors.organizationName"
                  :error-message="errors.organizationName"
                  class="q-mb-md"
                  @input="clearError('organizationName')"
                />
                <div class="row q-col-gutter-md">
                  <div class="col-12 col-md-6">
                      <q-input
                        v-model="firstName"
                        type="text"
                        label="Prénom"
                        color="grey-9"
                        clearable
                        filled
                        :error="!!errors.firstName"
                        :error-message="errors.firstName"
                        class="q-mb-md"
                        @input="clearError('firstName')"
                      />
                  </div>
                  <div class="col-12 col-md-6">
                      <q-input
                        v-model="lastName"
                        type="text"
                        label="Nom"
                        color="grey-9"
                        clearable
                        filled
                        :error="!!errors.lastName"
                        :error-message="errors.lastName"
                        class="q-mb-md"
                        @input="clearError('lastName')"
                      />
                  </div>
                </div>
                  <q-input
                    v-model="email"
                    type="email"
                    label="Email"
                    color="grey-9"
                    clearable
                    filled
                    :error="!!errors.email"
                    :error-message="errors.email"
                    class="q-mb-md"
                    @input="clearError('email')"
                  />
                  <q-input
                    v-model="password"
                    type="password"
                    label="Mot de passe"
                    color="grey-9"
                    clearable
                    filled
                    :error="!!errors.password"
                    :error-message="errors.password"
                    class="q-mb-md"
                    @input="clearError('password')"
                  />
                  <q-input
                    v-model="confirmPassword"
                    type="password"
                    label="Validation du mot de passe"
                    color="grey-9"
                    clearable
                    filled
                    :error="!!errors.confirmPassword"
                    :error-message="errors.confirmPassword"
                    class="q-mb-md"
                    @input="clearError('confirmPassword')"
                  />
                <div class="q-gutter-sm">
                  <q-btn
                    label="Créer mon compte"
                    :disabled="isSubmit"
                    type="submit"
                    class="text-white bg-grey-9"
                  />
                  <q-btn
                    label="Revenir à la connexion"
                    :disabled="isSubmit"
                    to="/login"
                    color="white"
                    class="q-ml-sm text-grey-9"
                  />
                </div>
              </q-form>
          </div>
          <div class="col"></div>
        </div>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script>
import { FormMixin } from '~/mixins';
import Header from '~/components/Header';
import { register } from '~/services/user';
import { notifySuccess } from '~/services/notify';

export default {
  name: 'register',
  mixins: [FormMixin],
  components: {
    Header
  },
  data() {
    return {
      userType: null,
      organizationName: '',
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      confirmPassword: '',
      errors: {},
      userTypeOptions: [
        { label: 'Bar', value: 'bar' },
        { label: 'BDE', value: 'bde' },
        { label: "Organisateur d'événements", value: 'event_organizer' }
      ]
    };
  },
  computed: {
    organizationLabel() {
      if (this.userType === 'bar') {
        return 'Nom du bar';
      }
      if (this.userType === 'bde') {
        return "Nom de l'association";
      }
      if (this.userType === 'event_organizer') {
        return "Nom de l'entreprise";
      }
      return "Nom du bar, de l'association ou de l'entreprise";
    }
  },
  methods: {
    clearError(field) {
      this.$set(this.errors, field, '');
    },
    validateForm() {
      const errors = {};
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}$/;

      if (!this.userType) {
        errors.userType = "Ce champ est obligatoire.";
      }
      if (!this.organizationName) {
        errors.organizationName = "Ce champ est obligatoire.";
      }
      if (!this.firstName) {
        errors.firstName = "Ce champ est obligatoire.";
      }
      if (!this.lastName) {
        errors.lastName = "Ce champ est obligatoire.";
      }
      if (!this.email) {
        errors.email = "Ce champ est obligatoire.";
      } else if (!emailRegex.test(this.email)) {
        errors.email = "Veuillez saisir une adresse e-mail valide.";
      }
      if (!this.password) {
        errors.password = "Ce champ est obligatoire.";
      } else if (!passwordRegex.test(this.password)) {
        errors.password = "Le mot de passe saisi est invalide. Il doit contenir au moins 6 caractères (et au moins 1 chiffre, 1 majuscule et 1 minuscule).";
      }
      if (!this.confirmPassword) {
        errors.confirmPassword = "Ce champ est obligatoire.";
      } else if (this.confirmPassword !== this.password) {
        errors.confirmPassword = "Les mots de passe saisis ne correspondent pas.";
      }

      this.errors = errors;
      return Object.keys(errors).length === 0;
    },
    setApiErrors(apiErrors = {}) {
      const nextErrors = {};
      if (apiErrors.userType && apiErrors.userType[0]) {
        nextErrors.userType = apiErrors.userType[0];
      }
      if (apiErrors.organizationName && apiErrors.organizationName[0]) {
        nextErrors.organizationName = apiErrors.organizationName[0];
      }
      if (apiErrors.firstName && apiErrors.firstName[0]) {
        nextErrors.firstName = apiErrors.firstName[0];
      }
      if (apiErrors.lastName && apiErrors.lastName[0]) {
        nextErrors.lastName = apiErrors.lastName[0];
      }
      if (apiErrors.email && apiErrors.email[0]) {
        nextErrors.email = apiErrors.email[0];
      }
      if (apiErrors.password && apiErrors.password[0]) {
        nextErrors.password = apiErrors.password[0];
      }
      if (apiErrors.confirmPassword && apiErrors.confirmPassword[0]) {
        nextErrors.confirmPassword = apiErrors.confirmPassword[0];
      }
      this.errors = nextErrors;
    },
    async processSubmit() {
      if (!this.validateForm()) {
        return Promise.resolve();
      }
      return register({
        userType: this.userType,
        organizationName: this.organizationName,
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        password: this.password,
        confirmPassword: this.confirmPassword
      }).then((response) => {
        if (response.status !== 201) {
          this.setApiErrors(response.data.errors);
        } else {
          notifySuccess('Compte créé. Utilisez votre email pour vous connecter.');
          this.$router.replace({ name: 'login' });
        }
      });
    }
  }
};
</script>
